module.exports = __webpack_public_path__ + "img/ltkmidsize-4x.23f9f7f.jpg";